import QuickDepositFailed from './QuickDepositFailed';

export default QuickDepositFailed;
